
import { Component } from '@angular/core';
import { CoreService } from 'src/app/services/core.service';

@Component({
  selector: 'app-branding',
  standalone: true,
  template: `
    <div class="branding">
      @if(options.theme === 'light') {
      <a href="/">
        <img
          src="./assets/images/logos/small_logo_hub.png"
          class="align-middle m-2"
          alt="logo"
          height="50px"
          style="margin-left: -10px !important;"
        />
      </a>
      } @if(options.theme === 'dark') {
      <a href="/">
        <img
          src="./assets/images/logos/logo_hub.png"
          class="align-middle m-2"
          alt="logo"
          height="50px"
          style="margin-left: -10px !important;"
        />
      </a>
      }
    </div>
  `,
})
export class BrandingComponent {
  options = this.settings.getOptions();

  constructor(private settings: CoreService) {}
}
